import api from "./base-api"

const audienceApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAllAudiences: build.query({
            query: () => {
                return {
                    url: `/admin/audience/list`,
                }
            },
            providesTags: ['Audience']
        }),
        getAudience: build.query({
            query: (id) => {
                return {
                    url: `/admin/audience?id=${id}`,
                    method: "POST",
                }

            },
            providesTags: ['Audience']
        }),
        updateAudience: build.mutation({
            query: (data) => {
                return {
                    url: `/admin/audience`,
                    method: "PUT",
                    body: data
                }

            },
            invalidatesTags: ['Audience']
        }),
        createAudience: build.mutation({
            query: (data) => {
                return {
                    url: `/admin/audience`,
                    method: "POST",
                    body: data
                }
            },
            invalidatesTags: ['Audience']
        }),
        deleteAudience: build.mutation({
            query: (id) => {
                return {
                    url: `/admin/audience/delete?id=${id}`,
                    method: "POST",
                }
            },
            invalidatesTags: ['Audience']
        }),
    }),
    overrideExisting: false
});

export const {
    useGetAllAudiencesQuery,
    useGetAudienceQuery,
    useUpdateAudienceMutation,
    useCreateAudienceMutation,
    useDeleteAudienceMutation
} = audienceApi